import React from 'react'
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import Tr from 'translations/Translations';
import Title from 'components/Title';
import GridBlock from 'components/GridBlock';
import Button from 'components/Button';
import clsx from 'clsx';
import Dialog from 'components/Dialog';

const style = theme => ({
	root: {
	},
	icon: {
		fontSize: theme.components.icon.fontSize,
	},
	padding: {
		paddingTop: theme.spacing(2)
	}
})

function SaveDialogBase({
	classes,
	onClose,
	children,
	title,
	Icon,
	iconClassName,
}) {

	return (
		<Dialog
			open={true}
			className={classes.root}
			transitionDuration={{ enter: 0 }}
			fullWidth={false}
			onClose={onClose}
		>
			<GridBlock justify='center' alignItems="center" className={classes.padding} direction="column">
				<Icon color='primary' className={clsx(classes.icon, iconClassName)} />
				<Title>{title}</Title>
			</GridBlock>

			{children}

			<GridBlock justify='center' className={classes.padding}>
				<Button onClick={onClose}> {Tr('close')} </Button>
			</GridBlock>
		</Dialog>
	)
}

SaveDialogBase.propTypes = {
	classes: PropTypes.any,
	onClose: PropTypes.func,
}

SaveDialogBase.defaultProps = {
}

export default withStyles(style)(SaveDialogBase);